import tw from "twin.macro";

export const VisuallyHidden = tw.span`sr-only`;
